/* Hover-intent for the mega-menu: opens 120ms after the pointer settles, closes 200ms after it leaves. Click/keyboard still work. */
(() => {
  const mq = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const OPEN_MS = 120;
  const CLOSE_MS = 200;
  let backdrop;
  let openTimer;
  let closeTimer;

  const getBackdrop = () => {
    if (backdrop) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'tac-mega-backdrop';
    document.body.appendChild(backdrop);
    return backdrop;
  };

  const setOpen = (details, open) => {
    if (open) {
      document.querySelectorAll('header-menu details[open]').forEach((d) => {
        if (d !== details) {
          d.removeAttribute('open');
          d.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });
      details.setAttribute('open', '');
      details.querySelector('summary').setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
    const anyOpen = !!document.querySelector('header-menu details[open]');
    getBackdrop().classList.toggle('is-on', anyOpen);
  };

  const bind = (menu) => {
    const details = menu.querySelector('details.mega-menu');
    if (!details) return;
    menu.addEventListener('pointerenter', () => {
      if (!mq.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(() => setOpen(details, true), OPEN_MS);
    });
    menu.addEventListener('pointerleave', () => {
      if (!mq.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => setOpen(details, false), CLOSE_MS);
    });
    details.addEventListener('toggle', () => {
      getBackdrop().classList.toggle('is-on', !!document.querySelector('header-menu details[open]'));
    });
  };

  const init = () => document.querySelectorAll('header-menu').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
